@if (project(); as project) {
  <div class="pad-top">
    <fw-grid>
      <fw-grid-item variant="page-shaded" [cols]="9">
        <project-statistics [loading]="project === undefined" [statistics]="project?.stats?.number_of" />
        <div class="card description-card">
          <h1 class="font-card-header has-button">
            Description
            @if (canEditDescription()) {
              <span>
                <span class="markdown-hint">Markdown Supported</span>
                @if (!editingDescription) {
                  <fw-button
                    color="primary"
                    leftIcon="edit"
                    test-id="edit-description-button"
                    variant="outline"
                    (click)="editingDescription = true"
                  >
                    Edit
                  </fw-button>
                }
              </span>
            }
          </h1>
          <div class="markdown-container">
            @if (project) {
              @if (!editingDescription) {
                @if (descriptionHtml) {
                  <p [innerHTML]="descriptionHtml"></p>
                }
                @if (!descriptionHtml) {
                  <div class="empty-description">
                    <fw-icon class="bright-blue md">edit</fw-icon>
                    <p>This project does not have a description.</p>
                    @if (canEditDescription()) {
                      <fw-button test-id="add-description-button" (click)="editingDescription = true">
                        Add Description
                      </fw-button>
                    }
                  </div>
                }
              } @else {
                <textarea
                  data-id="project-description-content"
                  name="description"
                  test-id="project-description-content"
                  [formControl]="projectDescription"
                ></textarea>
                @if (project) {
                  <fw-grid>
                    <fw-grid-item [cols]="4">
                      <p class="text-muted">
                        <small>{{ projectDescription.value?.length || 0 }} of 10000 characters</small>
                      </p>
                    </fw-grid-item>
                    <fw-grid-item [cols]="8">
                      <fw-button
                        color="slate"
                        test-id="cancel-description-button"
                        variant="outline"
                        (click)="editingDescription = false"
                      >
                        Cancel
                      </fw-button>
                      <fw-button
                        color="primary"
                        test-id="save-description-button"
                        [disabled]="projectDescription.invalid"
                        (click)="saveProjectDescription(project)"
                      >
                        Save
                      </fw-button>
                    </fw-grid-item>
                  </fw-grid>
                }
              }
            } @else {
              <fw-loading />
            }
          </div>
        </div>
      </fw-grid-item>
      <fw-grid-item variant="page-shaded" [cols]="3">
        @if (ohifEnabled) {
          <div class="card description-right-card">
            <h1 class="font-card-header">Viewer</h1>
            <fw-button test-id="viewer-study-list-button" [fullWidth]="true" (click)="viewProjectStudies()">
              Viewer Study List
            </fw-button>
          </div>
        }
        <div class="card description-right-card">
          <h1 class="font-card-header">Quick Tip</h1>
          <p>
            The project description can be used to provide users with context for the data in the project. Helpful
            information includes a description of the types of data collected, the subject population, and the research
            question the project addresses.
          </p>
          <p>A project's description is visible to all users with access to the project.</p>
        </div>
      </fw-grid-item>
    </fw-grid>
  </div>
}
